import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../incase-domain/components/button/Button';
import Label from '../../incase-domain/components/label/Label';

interface TextAlignProps {
    alignment?: string;
    onClick: (alignment: string) => void;
}

function TextAlign(props: TextAlignProps): JSX.Element {
    const {onClick, alignment = 'left'} = props;

    const {t} = useTranslation();

    const icons = [
        {icon: 'solar:align-left-linear', value: 'left'},
        {icon: 'solar:align-left-line-duotone', value: 'center'},
        {icon: 'solar:align-right-linear', value: 'right'},
    ];

    return (
        <div className="u-flex u-h-between u-v-center u-gap-2">
            <Label>{t('designSidepanel.textAlignment')}</Label>
            <div className="c-textAlign u-w-fc">
                {icons.map((icon, index) => {
                    return (
                        <Button
                            square
                            variant={alignment === icon.value ? 'soft' : 'ghost'}
                            size="sm"
                            leading={icon.icon}
                            color={alignment === icon.value ? 'secondary' : 'primary'}
                            key={index}
                            onClick={() => onClick(icon.value)}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default TextAlign;
